function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.5 19.7C4.4 19.7 4.2 19.6 4.1 19.6C4.1 19.4 4 19.3 4 19.2V10.9H18.6H19H20V7.4C20 7 19.8 6.6 19.6 6.4C19.3 6.1 18.9 6 18.5 6H16V4.5C16 4.2 15.8 4 15.5 4C15.2 4 15 4.2 15 4.5V6H8V4.5C8 4.2 7.8 4 7.5 4C7.2 4 7 4.2 7 4.5V6H4.5C4.1 6 3.7 6.2 3.4 6.4C3.2 6.7 3 7 3 7.4V19.2C3 19.6 3.2 20 3.4 20.2C3.7 20.5 4.1 20.6 4.5 20.6H10.8V19.6L4.5 19.7ZM4 7.4C4 7.3 4.1 7.2 4.1 7.1C4.2 7 4.3 7 4.5 7H7V8.5C7 8.8 7.2 9 7.5 9C7.8 9 8 8.7 8 8.4V7H15V8.5C15 8.8 15.2 9 15.5 9C15.8 9 16 8.7 16 8.4V7H18.5C18.6 7 18.8 7.1 18.9 7.1C18.9 7.2 19 7.3 19 7.4V9.8H4V7.4Z",
  fill: "#00AAFF"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.9992 11.7998L12.1992 17.6998V20.6998H15.0992L20.9992 14.7998L17.9992 11.7998ZM14.5992 19.4998H13.2992V18.0998L17.9992 13.3998L19.2992 14.6998L14.5992 19.4998Z",
  fill: "#00AAFF"
});
const SvgCloseVersionIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloseVersionIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/closeVersion_icon.98b08552.svg";
export { ForwardRef as ReactComponent };